/* unplugin-vue-components disabled */import script from "./menuModule.vue?vue&type=script&setup=true&lang=js"
export * from "./menuModule.vue?vue&type=script&setup=true&lang=js"

import "./menuModule.vue?vue&type=style&index=0&id=67c43128&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67c43128"]])

export default __exports__